'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIGrid from 'UIComponents/grid/UIGrid';
const StyledHeaderGrid = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, ["minBreakpoint", "maxBreakpoint"]);

  return /*#__PURE__*/_jsx(UIGrid, Object.assign({}, rest));
}).withConfig({
  displayName: "StyledHeaderGrid",
  componentId: "sc-1cdb4fl-0"
})(["&&{margin:auto;width:60%;&.sticky{width:100%;}@media only screen and (min-width:", ") and (max-width:", "){width:80%;}@media only screen and (max-width:", "){width:95%;}}"], props => props.minBreakpoint, props => props.maxBreakpoint, props => props.minBreakpoint);
StyledHeaderGrid.propTypes = {
  minBreakpoint: PropTypes.string.isRequired,
  maxBreakpoint: PropTypes.string.isRequired
};
export default StyledHeaderGrid;